<template>
    <div>

        <!-- Productie statistieken -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-bar-chart-o"></i>
            </h2>
            <div class="w-100">
                <h2>
                    Productie statistieken
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#productionStatistics" aria-expanded="true" aria-controls="productionStatistics">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="productionStatistics">

                <div class="d-flex flex-column flex-sm-row">
                    <div class="d-flex gap-4 gap-sm-0 w-100 mb-4 mt-sm-0">
                        <p class="mb-0 text-md text-lightgrey fw-medium">
                            Week {{ this.data.week }}
                        </p>
                        <div class="ms-4 d-flex align-items-center gap-4">
                            <span @click="setPrevWeek()" role="button">
                                <i class="fa fa-chevron-left"></i>
                            </span>
                            <span @click="setNextWeek()" role="button">
                                <i class="fa fa-chevron-right"></i>
                            </span>
                        </div>
                    </div>

                    <div class="text-decoration-none text-nowrap me-4" role="button">
                        <span class="bg-lightyellow text-primary round-btn me-2">
                            <i class="fa fa-link" aria-hidden="true"></i>
                        </span>
                        <a href="planning-production" class="fw-semibold" style="text-decoration: none;">
                            Naar planning productie
                        </a>
                    </div>

                </div>

                <table class="table content-full">
                    <thead>
                    <tr>
                        <th colspan="2" class="mb-1 ml-2">Openstaande werken</th>
                        <th class="mb-1 ml-2 text-end">Hoeken</th>
                        <th class="mb-1 ml-2 text-end">Elementen</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <div>
                                <p class="mb-0 text-sm fw-semibold">
                                    Montages
                                </p>
                            </div>
                        </td>
                        <td>
                            <span class="round-icon round-md bg-lightyellow text-primary">
                                {{ this.data.outstandingWorkMontages }}
                            </span>
                        </td>
                        <td class="text-end">
                            <span class="mb-0 ms-auto mx-2 text-lg">
                                {{ this.data.outstandingWorkMontagesHooks }}
                            </span>
                        </td>
                        <td class="text-end">
                            <span class="mb-0 ms-auto mx-2 text-lg">
                                {{ this.data.outstandingWorkMontagesElements }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                                <p class="mb-0 text-sm fw-semibold">
                                    Leveringen
                                </p>
                            </div>
                        </td>
                        <td>
                            <span class="round-icon round-md  bg-lightgreen text-green">
                                {{ this.data.outstandingWorkDeliveries }}
                            </span>
                        </td>
                        <td class="text-end">
                            <span class="mb-0 ms-auto mx-2 text-lg">
                                {{ this.data.outstandingWorkDeliveriesHooks }}
                            </span>
                        </td>
                        <td class="text-end">
                            <span class="mb-0 ms-auto mx-2 text-lg">
                                {{ this.data.outstandingWorkDeliveriesElements }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                                <p class="mb-0 text-sm fw-semibold">
                                    Services
                                </p>
                            </div>
                        </td>
                        <td>
                            <span class=" round-icon round-md bg-lightblue text-blue">
                                {{ this.data.outstandingWorkServices }}
                            </span>
                        </td>
                        <td class="text-end">
                            <span class="mb-0 ms-auto mx-2 text-lg">
                                {{ this.data.outstandingWorkServicesHooks }}
                            </span>
                        </td>
                        <td class="text-end">
                            <span class="mb-0 ms-auto mx-2 text-lg">
                                {{ this.data.outstandingWorkServicesElements }}
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="d-flex mb-3">
                    <h4 class="mb-1 ml-2">
                        Statistieken
                    </h4>
                </div>
                <div v-if="this.data.userSummary.length < 1">
                    Geen statistieken gevonden
                </div>
                <div v-else>
                    <table class="table table-responsive">
                        <thead>
                        <tr>
                            <th class="text-sm fw-semibold text-lightgrey border-0">Productie<span class="hyphen">-</span>medewerker</th>
                            <th class="text-sm fw-semibold text-lightgrey border-0 text-end">Totaal producten</th>
                            <th class="text-sm fw-semibold text-lightgrey border-0 text-end">Hoeken</th>
                            <th class="text-sm fw-semibold text-lightgrey border-0 text-end">Elementen</th>
                        </tr>
                        </thead>
                        <tbody class="fw-medium">
                        <tr v-for="user in this.data.userSummary">
                            <td class="fw-semibold">{{ user.user_name }}</td>
                            <td class="text-end">{{ user.total_products }}</td>
                            <td class="text-end">{{ user.total_hooks }}</td>
                            <td class="text-end">{{ user.total_elements }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

    import {useComponentVisibility} from "../../composables/useComponentVisibility";

    export default {
        name: 'production-statistics',
        components: {},
        props: {
            dateToday: String,
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: {
                    date: '',
                    week: '',
                    year: '',
                    pagination: [{
                        next: {
                            date: '',
                        },
                        prev: {
                            date: '',
                         }
                    }],
                    userSummary: [{
                        key: {
                            user_name: '',
                            total_products: '',
                            total_hooks: '',
                            total_elements: '',
                            ts_production_done: '',
                        }
                    }],
                    outstandingWorkMontages: '',
                    outstandingWorkMontagesHooks: '',
                    outstandingWorkMontagesElements: '',
                    outstandingWorkDeliveries: '',
                    outstandingWorkDeliveriesHooks: '',
                    outstandingWorkDeliveriesElements: '',
                    outstandingWorkServices: '',
                    outstandingWorkServicesHooks: '',
                    outstandingWorkServicesElements: '',
                },

                componentId: 'production-statistics-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });

                if(this.componentIsVisable) {
                    this.loading = true;
                    this.getProductionStatistics();
                }
            },
            getProductionStatistics() {
                axios.get('api/production-statistics?date='+this.data.date)
                    .then(response => {
                       this.data = response.data;

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            setPrevWeek() {
                this.loading = true;
                this.data.date = this.data.pagination.prev.date;
                this.getProductionStatistics();
            },
            setNextWeek() {
                this.loading = true;
                this.data.date = this.data.pagination.next.date;
                this.getProductionStatistics();
            },


        },
        mounted() {
            if(this.isVisible) {
                this.getProductionStatistics();
            } else {
                this.loading = false;
            }
        },
        created() {},
    }
</script>
<style>
    thead {
        tr th {
            border: none;
            font-weight: 600;
            font-size: 18px !important;
            padding-bottom: 1rem !important;
            #text-align: right;
        }
    }

    tbody {
        tr td {
            #text-align: right;
        }
    }
</style>
